export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeTypeMst: {
        noticeTypeMstId: 1,
        noticeTypeMstUuid: 'noticeType001',
        noticeTypeName: 'テキストのみ',
        noticeType: 'text',
        screenId: 'BUSCF00015',
        screenIdMstUuid: 'screenidmst001',
        noticeTypeStatus: 1
      }
    }
  }
}